import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'TagSelecter',
  props: ["value", "placeholder", "limit", "prefix"],
  emits: ["input"],
  setup(__props) {




return (_ctx: any,_cache: any) => {
  const _component_a_option = _resolveComponent("a-option")!
  const _component_a_optgroup = _resolveComponent("a-optgroup")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    placeholder: __props.placeholder,
    "allow-search": { retainInputValue: true },
    value: __props.value,
    onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('input', $event.target.value))),
    multiple: "",
    limit: __props.limit,
    style: {"min-width":"200px"}
  }, {
    prefix: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.prefix), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_optgroup, { label: "Java" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("Java")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("Java基础")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("Java集合")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("Java多线程")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("Java并发")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("Java虚拟机")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("Java反射")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("Java IO")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_optgroup, { label: "Spring" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("Spring")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("Spring MVC")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("Spring Boot")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("Spring Cloud")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_optgroup, { label: "数据库" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("MySQL")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("Redis")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("ES")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("MongoDB")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_optgroup, { label: "计算机基础" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("算法")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("数据结构")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("计算机网络")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("操作系统")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_optgroup, { label: "操作系统" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("Linux")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("Windows")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("Mac")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_optgroup, { label: "后端" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("后端")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("后端基础")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("后端框架")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("后端设计模式")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("后端数据库")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("后端网络")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("后端安全")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_optgroup, { label: "前端" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("HTML")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("CSS")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("JavaScript")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("Vue")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("React")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_optgroup, { label: "其他" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("Git")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("Maven")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("Gradle")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("Jenkins")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("Docker")
            ]),
            _: 1
          }),
          _createVNode(_component_a_option, null, {
            default: _withCtx(() => [
              _createTextVNode("Kubernetes")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["placeholder", "value", "limit"]))
}
}

})